import { IGrainProfileExtended, IUserSubscription } from 'src/models';

export type OperatorCaptureMode = 'SCANNER' | 'CAMERA';

const normalizeProductType = (value?: string) => String(value || '').trim().toUpperCase();

export const isActiveSubscription = (subscription: IUserSubscription): boolean => {
    const status = normalizeProductType(subscription.status);
    if (status !== 'SUBSCRIPTION_ACTIVE' && status !== 'SUBCRIPTION_ACTIVE') return false;

    const rawExpiry = Number(subscription.expiry ?? 0);
    const expiryMs = rawExpiry > 0 && rawExpiry < 1_000_000_000_000
        ? rawExpiry * 1000
        : rawExpiry;
    return !expiryMs || expiryMs > Date.now();
};

export const getOperatorCaptureMode = ({
    selectedProfile,
    subscriptions = [],
}: {
    selectedProfile?: IGrainProfileExtended;
    subscriptions?: IUserSubscription[];
}): OperatorCaptureMode => {
    const profileType = normalizeProductType(selectedProfile?.profileType);
    if (profileType === 'SEED_COUNTER') return 'CAMERA';
    if (profileType) return 'SCANNER';

    const hasActiveSeedCounter = subscriptions.some(
        subscription => normalizeProductType(subscription.productType) === 'SEED_COUNTER'
            && isActiveSubscription(subscription)
    );

    return hasActiveSeedCounter ? 'CAMERA' : 'SCANNER';
};
